module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_vm._v("\n      " + _vm._s(tabitem) + "\n    ")])
  }), 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "value": ("tab-" + n)
      }
    }, [_c('v-layout', {
      staticClass: "pa-1"
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md9": "",
        "offset-sm3": "",
        "mx-auto": ""
      }
    }, [(tabitem === 'heads') ? _c('div', {
      staticClass: "text-xs-right caption ma-2 grey--text"
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("lock")]), _vm._v(" - System defaults which can not be modified\n                ")], 1) : _c('div', [_c('v-layout', {
      staticClass: "ml-1 mr-1",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs9": "",
        "sm4": ""
      }
    }, [_c('v-select', {
      attrs: {
        "label": "Maintenance period",
        "items": _vm.periods
      },
      on: {
        "input": function($event) {
          return _vm.loadHeads()
        }
      },
      model: {
        value: (_vm.period),
        callback: function($$v) {
          _vm.period = $$v
        },
        expression: "period"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-switch', {
      attrs: {
        "label": "Filter accounts with opening balance",
        "hide-details": ""
      },
      model: {
        value: (_vm.filterBal),
        callback: function($$v) {
          _vm.filterBal = $$v
        },
        expression: "filterBal"
      }
    })], 1), _vm._v(" "), (tabitem !== 'heads') ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm8": "",
        "mx-auto": ""
      }
    }, [_c('v-layout', {
      class: 'mr-1 subheading white--text ' + (_vm.totDebit === _vm.totCredit ? 'success' : 'error'),
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "sm4": ""
      }
    }, [_c('strong', [_vm._v("Total ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs5": "",
        "sm4": ""
      }
    }, [_c('strong', [_vm._v("Debit: " + _vm._s(_vm.handy.formatCur(_vm.totDebit)))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs5": "",
        "sm4": ""
      }
    }, [_c('strong', [_vm._v("Credit: " + _vm._s(_vm.handy.formatCur(_vm.totCredit)))])]), _vm._v(" "), (_vm.totDebit !== _vm.totCredit) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                            Difference in opening balance " + _vm._s(_vm.handy.formatCur(_vm.totDebit - _vm.totCredit)) + "\n                          ")])]) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _vm._l((_vm.types), function(hType, t) {
      return _c('div', {
        key: t
      }, [(hType !== 'PERSONAL' || tabitem === 'opening balance') ? _c('v-card', {
        staticClass: "mb-3"
      }, [_c('v-card-title', {
        staticClass: "pa-2 grey lighten-4"
      }, [_c('div', {
        staticClass: "title grey--text"
      }, [_vm._v(_vm._s(hType))])]), _vm._v(" "), _c('v-card-text', {
        staticClass: "pa-0"
      }, [_c('v-data-table', {
        attrs: {
          "headers": tabitem === 'heads' ? _vm.headHead : _vm.balHead,
          "items": _vm.heads[hType],
          "hide-actions": "",
          "disable-initial-sort": "",
          "hide-actions": ""
        },
        scopedSlots: _vm._u([{
          key: "items",
          fn: function(props) {
            return [(!_vm.filterBal || props.item.opening_debit || props.item.opening_credit) ? _c('tr', {
              on: {
                "click": function($event) {
                  tabitem !== 'heads' ? _vm.prepareUpdateBal(props.item) : !props.item.is_system_acc ? _vm.prepareUpdate(props.item) : ''
                }
              }
            }, [_c('td', [_vm._v(_vm._s(props.item.gl_acc_name))]), _vm._v(" "), (tabitem === 'heads') ? _c('td', [(props.item.is_system_acc) ? _c('v-icon', {
              attrs: {
                "small": ""
              }
            }, [_vm._v("lock")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (tabitem !== 'heads') ? _c('td', {
              staticClass: "text-xs-right"
            }, [_vm._v(_vm._s((props.item.opening_debit ? _vm.handy.formatCur(props.item.opening_debit) : props.item.opening_debit)))]) : _vm._e(), _vm._v(" "), (tabitem !== 'heads') ? _c('td', {
              staticClass: "text-xs-right"
            }, [_vm._v(_vm._s((props.item.opening_credit ? _vm.handy.formatCur(props.item.opening_credit) : props.item.opening_credit)))]) : _vm._e()]) : _vm._e()]
          }
        }], null, true)
      })], 1)], 1) : _vm._e()], 1)
    })], 2)], 1)], 1)
  }), _vm._v(" "), (_vm.tab === 'tab-0') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dlgHead),
      callback: function($$v) {
        _vm.dlgHead = $$v
      },
      expression: "dlgHead"
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.tab === 'tab-0' ? _vm.saveChanges(_vm.lAction) : _vm.saveChanges('update-op-bal')
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.tab === 'tab-1') ? _c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.lHead.gl_acc_name + ' (' + _vm.lHead.gl_acc_type + ')') + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.tab === 'tab-0') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Head Name",
      "rules": [_vm.rules.required],
      "maxlength": "50"
    },
    model: {
      value: (_vm.lHead.gl_acc_name),
      callback: function($$v) {
        _vm.$set(_vm.lHead, "gl_acc_name", $$v)
      },
      expression: "lHead.gl_acc_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "items": ['ASSET', 'LIABILITY', 'INCOME', 'EXPENSE'],
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lHead.gl_acc_type),
      callback: function($$v) {
        _vm.$set(_vm.lHead, "gl_acc_type", $$v)
      },
      expression: "lHead.gl_acc_type"
    }
  })], 1), _vm._v(" "), (_vm.lHead.gl_acc_type === 'ASSET' || _vm.lHead.gl_acc_type === 'LIABILITY') ? _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Class (choose/enter new)",
      "items": _vm.hclass[_vm.lHead.gl_acc_type],
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lHead.gl_acc_class),
      callback: function($$v) {
        _vm.$set(_vm.lHead, "gl_acc_class", $$v)
      },
      expression: "lHead.gl_acc_class"
    }
  })], 1) : _vm._e()], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Debit', 'Credit'],
      "hint": _vm.lHead.gl_acc_type === 'PERSONAL' ? (_vm.lHead.bal_trans_type === 'Debit' ? 'i.e due from this person' : 'i.e you owe to this person') : '',
      "persistent-hint": ""
    },
    on: {
      "input": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.lHead.bal_trans_type),
      callback: function($$v) {
        _vm.$set(_vm.lHead, "bal_trans_type", $$v)
      },
      expression: "lHead.bal_trans_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.config.CURRENCY,
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lHead.bal_amount),
      callback: function($$v) {
        _vm.$set(_vm.lHead, "bal_amount", $$v)
      },
      expression: "lHead.bal_amount"
    }
  })], 1), _vm._v(" "), (_vm.lHead.gl_acc_type === 'PERSONAL') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "value": "true",
      "color": "info"
    }
  }, [(_vm.lHead.bal_trans_type === 'Debit') ? _c('span', [_vm._v("\n                      Don't forget to "), _c('strong', [_vm._v("credit")]), _vm._v(" corresponding income heads for this due amount to balance the total amount. Ignore if already done.\n                    ")]) : _c('span', [_vm._v("\n                      Don't forget to "), _c('strong', [_vm._v("debit")]), _vm._v(" corresponding bank/cash heads for this excess/surplus amount to balance the total amount. Ignore if already done.\n                    ")])])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.tab === 'tab-0' && _vm.lAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteHead($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.beingSaved,
      "type": "submit",
      "color": "accent",
      "flat": ""
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20%",
      "left": "50%"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a277323","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Heads.vue
// module id = 838
// module chunks = 43